import * as Yup from 'yup';

const registrationRejectionReasonSchema = Yup.object().shape({
  en: Yup.string().trim().required('English text is required'),
  ar: Yup.string().trim().required('Arabic text is required'),
  sortOrder: Yup.number().min(0).required('Sort order is required'),
  activeState: Yup.boolean().required(),
});

export default registrationRejectionReasonSchema;
